module.exports = __webpack_public_path__ + "media/images/icons/laptop-ef992b704ca1e9a52598474e7de131d4.svg";